import { Injectable } from "@angular/core";

@Injectable()
export class UserService {
    connectedUser : any;
    constructor() {   
    }

    getConnnectedUser(){
        return !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : null;
    }
    getConnnectedUserRoleCodes(){
        return this.getConnnectedUser() ? 
               this.getConnnectedUser().fonctionnaliteAutorise.filter(role => role.Statut).map(role => role.Code) :
               []
    }

    isEditableForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_UPDATE`);
    }

    isDeletableForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_CANCEL`);
    }

    isAddableForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_ADD`);
    }

    isAuthorizedToAccessMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === menuCode);
    }

    isDisableForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_DISABLE`);
    }
    
    isResetPasswordForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_RESET_PASSWORD`);
    }

    isExportForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_EXPORT`);
    }
    isShowSoldeForMenu(menuCode: string){
        return this.getConnnectedUserRoleCodes().some(code => code === `${menuCode}_SHOW_SOLDE`);
    }

}